export default __webpack_public_path__ + "a43e1f63f558146bbc7b9954eb8d1b53.png";